import axios from "axios";
import { useState, useEffect } from "react";

export default function MeasurementMaintenance({ onBack, selected_plant_id }) {
  const [selectedHeight, setSelectedHeight] = useState("");
  const [selectedHeightFrom, setSelectedHeightFrom] = useState("substrate");
  const [selectedHeightTo, setSelectedHeightTo] = useState("apical_meristem");
  const [selectedWidth, setSelectedWidth] = useState("");
  const [selectedStemDiameter, setSelectedStemDiameter] = useState("");
  const [selectedNodeCount, setSelectedNodeCount] = useState("");
  const [selectedBranchCount, setSelectedBranchCount] = useState("");
  const [selectedLai, setSelectedLai] = useState("");
  const [selectedPlantingDensity, setSelectedPlantingDensity] = useState("");
  const [selectedLightIntensity, setSelectedLightIntensity] = useState("");
  const [selectedLightMeasuredAt, setSelectedLightMeasuredAt] =
    useState("canopy");
  const [selectedRedPPFD, setSelectedRedPPFD] = useState("");
  const [selectedFarRedPPFD, setSelectedFarRedPPFD] = useState("");
  const [selectedGreenPPFD, setSelectedGreenPPFD] = useState("");
  const [selectedBluePPFD, setSelectedBluePPFD] = useState("");
  const [selectedFlowerThickness, setSelectedFlowerThickness] = useState("");
  const [selectedWeight, setSelectedWeight] = useState("");
  const [selectedWeightIncludes, setSelectedWeightIncludes] = useState(
    "plant_container_substrate"
  );
  const [plantCount, setPlantCount] = useState(0);

  // Check if we have multiple plants (from a plot)
  useEffect(() => {
    if (Array.isArray(selected_plant_id)) {
      setPlantCount(selected_plant_id.length);
      console.log(
        `Found ${selected_plant_id.length} plants for measurement maintenance`
      );
    }
  }, [selected_plant_id]);

  const [openSubs, setOpenSubs] = useState(new Set());
  const toggle = (key) =>
    setOpenSubs((prev) => {
      const next = new Set(prev);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });

  const org_id = localStorage.getItem("organization");

  const handleUpload = async () => {
    console.log("Selected plant ID:", selected_plant_id);
    try {
      // Prepare the basic measurement data
      const measurementData = {
        branch_count: selectedBranchCount
          ? parseInt(selectedBranchCount)
          : null,
        flower_thickness_mm: selectedFlowerThickness
          ? parseFloat(selectedFlowerThickness)
          : null,
        height_cm: selectedHeight ? parseFloat(selectedHeight) : null,
        height_from: !selectedHeight ? null : selectedHeightFrom || null,
        height_to: !selectedHeight ? null : selectedHeightTo || null,
        lai_m2m2: selectedLai ? parseFloat(selectedLai) : null,
        light_blue: selectedBluePPFD ? parseFloat(selectedBluePPFD) : null,
        light_farred: selectedFarRedPPFD
          ? parseFloat(selectedFarRedPPFD)
          : null,
        light_green: selectedGreenPPFD ? parseFloat(selectedGreenPPFD) : null,
        light_measured_at: !selectedLightIntensity
          ? null
          : selectedLightMeasuredAt || null,
        light_ppfd: selectedLightIntensity
          ? parseFloat(selectedLightIntensity)
          : null,
        light_red: selectedRedPPFD ? parseFloat(selectedRedPPFD) : null,
        node_count: selectedNodeCount ? parseInt(selectedNodeCount) : null,
        planting_density_m2: selectedPlantingDensity
          ? parseFloat(selectedPlantingDensity)
          : null,
        stem_diameter_mm: selectedStemDiameter
          ? parseFloat(selectedStemDiameter)
          : null,
        weight_g: selectedWeight ? parseFloat(selectedWeight) : null,
        weight_includes: !selectedWeight
          ? null
          : selectedWeightIncludes || null,
        width_cm: selectedWidth ? parseFloat(selectedWidth) : null,
      };

      // Check if at least one measurement was provided
      const hasData = Object.values(measurementData).some(
        (value) => value !== null
      );

      if (!hasData) {
        alert("Please provide at least one measurement");
        return;
      }

      // Send a single request with the array of plant IDs
      const plantIds = Array.isArray(selected_plant_id)
        ? selected_plant_id
        : [selected_plant_id];

      const requestData = {
        ...measurementData,
        plant_id: plantIds,
      };

      await axios.post(`/orgs/${org_id}/maintenance/measurement`, requestData, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      });

      alert("Upload complete");
      onBack && onBack(); // Return to previous screen after successful upload
    } catch (err) {
      console.error("Upload failed:", err);
      if (err.response?.status === 400) {
        alert(
          "Upload failed - Check if all required fields are filled in correctly"
        );
      } else if (err.response?.status === 401 || err.response?.status === 403) {
        alert(
          "Upload failed - You are no longer logged in or you don't have access to this resource"
        );
      } else if (err.response?.status === 500) {
        alert(
          "Upload failed - Something went wrong in the service, please try again later"
        );
      } else {
        alert(`Upload failed with error: ${err.response}`);
      }
    }
  };

  return (
    <>
      {/* header & back -------------------------------------------------- */}
      <div className="maintenanceHeader">
        <h3>Measurement</h3>
        <button className="uploadMaintenanceBtn" onClick={handleUpload}>
          Upload
        </button>
      </div>

      <div className="maintenaceGrid maintenanceList">
        <div className="dropdownBlock">
            <div
                className="purpleBtn extraGridBtn blueBtn"
                onClick={() =>
                    openSubs.size > 0 ? setOpenSubs(new Set()) : onBack()
                }
            >
                {openSubs.size > 0 ? "Back to Categories" : "Back"}
            </div>
            </div>

        {plantCount > 1 && (
          <div className="plotMaintenanceNotice">
            Applying measurement maintenance to all plants in plot ({plantCount}{" "}
            plants)
          </div>
        )}
      </div>

      <div className="maintenaceGrid maintenanceList flexMaintenanceGrid">
        {!openSubs.has("height") &&
        !openSubs.has("width") &&
        !openSubs.has("stemDiameter") &&
        !openSubs.has("nodeCount") &&
        !openSubs.has("branchCount") &&
        !openSubs.has("lai") &&
        !openSubs.has("plantingDensity") &&
        !openSubs.has("lightIntensity") &&
        !openSubs.has("flowerThickness") &&
        !openSubs.has("weight") ? (
          <>
            <div className="purpleBox" onClick={() => toggle("height")}>
              Height
            </div>
            <div className="purpleBox" onClick={() => toggle("width")}>
              Width
            </div>
            <div className="purpleBox" onClick={() => toggle("stemDiameter")}>
              Stem Diameter
            </div>
            <div className="purpleBox" onClick={() => toggle("nodeCount")}>
              Node Count
            </div>
            <div className="purpleBox" onClick={() => toggle("branchCount")}>
              Branch Count
            </div>
            <div className="purpleBox" onClick={() => toggle("lai")}>
              LAI
            </div>
            <div
              className="purpleBox"
              onClick={() => toggle("plantingDensity")}
            >
              Planting Density
            </div>
            <div className="purpleBox" onClick={() => toggle("lightIntensity")}>
              Light Intensity
            </div>
            <div
              className="purpleBox"
              onClick={() => toggle("flowerThickness")}
            >
              Flower Thickness
            </div>
            <div className="purpleBox" onClick={() => toggle("weight")}>
              Weight
            </div>
          </>
        ) : openSubs.has("height") ? (
          <table className="maintenanceTable">
            <tbody>
              <tr>
                <td>
                  <p>Height:</p>
                </td>
                <td style={{ position: "relative" }}>
                  <input
                    className="newMaintenanceInput"
                    type="text"
                    value={selectedHeight}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" || e.key === "Delete") return;
                      const isNumber = /[0-9]/.test(e.key);
                      const isDot = e.key === ".";
                      const hasDot = e.target.value.includes(".");
                      if ((!isNumber && !isDot) || (isDot && hasDot)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d*\.?\d*$/.test(value)) {
                        if (
                          value.includes(".") &&
                          value.split(".")[1]?.length > 1
                        ) {
                          return;
                        }
                        setSelectedHeight(value);
                      }
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "14vw",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#666",
                    }}
                  >
                    cm
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <p>From:</p>
                </td>
                <td>
                  <label>
                    <input
                      type="radio"
                      name="from"
                      value="substrate"
                      checked={selectedHeightFrom === "substrate"}
                      onChange={(e) => setSelectedHeightFrom(e.target.value)}
                      className="tableRadio tableRadioScouting"
                    />
                    Substrate
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="from"
                      value="table"
                      checked={selectedHeightFrom === "table"}
                      onChange={(e) => setSelectedHeightFrom(e.target.value)}
                      className="tableRadio tableRadioScouting"
                    />
                    Table
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="from"
                      value="lowest_shoot"
                      checked={selectedHeightFrom === "lowest_shoot"}
                      onChange={(e) => setSelectedHeightFrom(e.target.value)}
                      className="tableRadio tableRadioScouting"
                    />
                    Lowest shoot
                  </label>
                </td>
              </tr>
              <tr>
                <td>
                  <p>To:</p>
                </td>
                <td>
                  <label>
                    <input
                      type="radio"
                      name="to"
                      value="apical_meristem"
                      checked={selectedHeightTo === "apical_meristem"}
                      onChange={(e) => setSelectedHeightTo(e.target.value)}
                      className="tableRadio tableRadioScouting"
                    />
                    Apical meristem
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="to"
                      value="highest_point"
                      checked={selectedHeightTo === "highest_point"}
                      onChange={(e) => setSelectedHeightTo(e.target.value)}
                      className="tableRadio tableRadioScouting"
                    />
                    Highest point
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
        ) : openSubs.has("width") ? (
          <table className="maintenanceTable">
            <tbody>
              <tr>
                <td>
                  <p>Width:</p>
                </td>
                <td style={{ position: "relative" }}>
                  <input
                    className="newMaintenanceInput"
                    type="text"
                    value={selectedWidth}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" || e.key === "Delete") return;
                      const isNumber = /[0-9]/.test(e.key);
                      const isDot = e.key === ".";
                      const hasDot = e.target.value.includes(".");
                      if ((!isNumber && !isDot) || (isDot && hasDot)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d*\.?\d*$/.test(value)) {
                        if (
                          value.includes(".") &&
                          value.split(".")[1]?.length > 1
                        ) {
                          return;
                        }
                        setSelectedWidth(value);
                      }
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "14vw",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#666",
                    }}
                  >
                    cm
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        ) : openSubs.has("stemDiameter") ? (
          <table className="maintenanceTable">
            <tbody>
              <tr>
                <td>
                  <p>Stem Diameter:</p>
                </td>
                <td style={{ position: "relative" }}>
                  <input
                    className="newMaintenanceInput"
                    type="text"
                    value={selectedStemDiameter}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" || e.key === "Delete") return;
                      const isNumber = /[0-9]/.test(e.key);
                      const isDot = e.key === ".";
                      const hasDot = e.target.value.includes(".");
                      if ((!isNumber && !isDot) || (isDot && hasDot)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d*\.?\d*$/.test(value)) {
                        if (
                          value.includes(".") &&
                          value.split(".")[1]?.length > 1
                        ) {
                          return;
                        }
                        setSelectedStemDiameter(value);
                      }
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "11vw",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#666",
                    }}
                  >
                    mm
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        ) : openSubs.has("nodeCount") ? (
          <table className="maintenanceTable">
            <tbody>
              <tr>
                <td>
                  <p>Node Count:</p>
                </td>
                <td style={{ position: "relative" }}>
                  <input
                    className="newMaintenanceInput"
                    type="text"
                    value={selectedNodeCount}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" || e.key === "Delete") return;
                      const isNumber = /[0-9]/.test(e.key);
                      if (!isNumber) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d+$/.test(value)) {
                        setSelectedNodeCount(value);
                      }
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "12vw",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#666",
                    }}
                  >
                    nodes
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        ) : openSubs.has("branchCount") ? (
          <table className="maintenanceTable">
            <tbody>
              <tr>
                <td>
                  <p>Branch Count:</p>
                </td>
                <td style={{ position: "relative" }}>
                  <input
                    className="newMaintenanceInput"
                    type="text"
                    value={selectedBranchCount}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" || e.key === "Delete") return;
                      const isNumber = /[0-9]/.test(e.key);
                      if (!isNumber) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d+$/.test(value)) {
                        setSelectedBranchCount(value);
                      }
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "12vw",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#666",
                    }}
                  >
                    branches
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        ) : openSubs.has("lai") ? (
          <table className="maintenanceTable">
            <tbody>
              <tr>
                <td>
                  <p>Leaf Area Index (LAI):</p>
                </td>
                <td style={{ position: "relative" }}>
                  <input
                    className="newMaintenanceInput"
                    type="text"
                    value={selectedLai}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" || e.key === "Delete") return;
                      const isNumber = /[0-9]/.test(e.key);
                      const isDot = e.key === ".";
                      const hasDot = e.target.value.includes(".");
                      if ((!isNumber && !isDot) || (isDot && hasDot)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d*\.?\d*$/.test(value)) {
                        if (
                          value.includes(".") &&
                          value.split(".")[1]?.length > 1
                        ) {
                          return;
                        }
                        setSelectedLai(value);
                      }
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "10.5vw",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#666",
                    }}
                  >
                    m²m⁻²
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        ) : openSubs.has("plantingDensity") ? (
          <table className="maintenanceTable">
            <tbody>
              <tr>
                <td>
                  <p>Planting Density:</p>
                </td>
                <td style={{ position: "relative" }}>
                  <input
                    className="newMaintenanceInput"
                    type="text"
                    value={selectedPlantingDensity}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" || e.key === "Delete") return;
                      const isNumber = /[0-9]/.test(e.key);
                      const isDot = e.key === ".";
                      const hasDot = e.target.value.includes(".");
                      if ((!isNumber && !isDot) || (isDot && hasDot)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d*\.?\d*$/.test(value)) {
                        if (
                          value.includes(".") &&
                          value.split(".")[1]?.length > 1
                        ) {
                          return;
                        }
                        setSelectedPlantingDensity(value);
                      }
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "11vw",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#666",
                    }}
                  >
                    #/m²
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        ) : openSubs.has("lightIntensity") ? (
          <table className="maintenanceTable">
            <tbody>
              <tr>
                <td>
                  <p>Light Intensity:</p>
                </td>
                <td style={{ position: "relative" }}>
                  <input
                    className="newMaintenanceInput"
                    type="text"
                    name="lightIntensity"
                    value={selectedLightIntensity}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" || e.key === "Delete") return;
                      const isNumber = /[0-9]/.test(e.key);
                      const isDot = e.key === ".";
                      const hasDot = e.target.value.includes(".");
                      if ((!isNumber && !isDot) || (isDot && hasDot)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value !== "") {
                        const ppfdValue = parseFloat(value);
                        if (ppfdValue > 2500) {
                          alert(
                            "Light intensity (PPFD) should be between 0 and 2500"
                          );
                          return;
                        }
                      }
                      if (value === "" || /^\d*\.?\d*$/.test(value)) {
                        if (
                          value.includes(".") &&
                          value.split(".")[1]?.length > 1
                        ) {
                          return;
                        }
                        setSelectedLightIntensity(value);
                      }
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "13vw",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#666",
                    }}
                  >
                    PPFD
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <p>Measured at:</p>
                </td>
                <td>
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
                  >
                    <label style={{ display: "flex", alignItems: "center" }}>
                      <input
                        name="measuredAt"
                        type="radio"
                        value="canopy"
                        checked={selectedLightMeasuredAt === "canopy"}
                        onChange={(e) =>
                          setSelectedLightMeasuredAt(e.target.value)
                        }
                        className="tableRadio tableRadioScouting"
                      />
                      Canopy level
                    </label>
                    <label style={{ display: "flex", alignItems: "center" }}>
                      <input
                        type="radio"
                        name="measuredAt"
                        value="table"
                        checked={selectedLightMeasuredAt === "table"}
                        onChange={(e) =>
                          setSelectedLightMeasuredAt(e.target.value)
                        }
                        className="tableRadio tableRadioScouting"
                      />
                      Table level
                    </label>
                    <label style={{ display: "flex", alignItems: "center" }}>
                      <input
                        type="radio"
                        name="measuredAt"
                        value="substrate"
                        checked={selectedLightMeasuredAt === "substrate"}
                        onChange={(e) =>
                          setSelectedLightMeasuredAt(e.target.value)
                        }
                        className="tableRadio tableRadioScouting"
                      />
                      Substrate level
                    </label>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <p>Spectrum PPFD:</p>
                </td>
                <td>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ width: "50px", marginRight: "10px" }}>
                        Red:
                      </span>
                      <input
                        className="newMaintenanceInput"
                        type="text"
                        value={selectedRedPPFD}
                        onKeyDown={(e) => {
                          if (e.key === "Backspace" || e.key === "Delete")
                            return;
                          const isNumber = /[0-9]/.test(e.key);
                          const isDot = e.key === ".";
                          const hasDot = e.target.value.includes(".");
                          if ((!isNumber && !isDot) || (isDot && hasDot)) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value !== "") {
                            const ppfdValue = parseFloat(value);
                            if (ppfdValue > 2500) {
                              alert(
                                "Light intensity (PPFD) should be between 0 and 2500"
                              );
                              return;
                            }
                          }
                          if (value === "" || /^\d*\.?\d*$/.test(value)) {
                            if (
                              value.includes(".") &&
                              value.split(".")[1]?.length > 1
                            ) {
                              return;
                            }
                            setSelectedRedPPFD(value);
                          }
                        }}
                      />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ width: "50px", marginRight: "10px" }}>
                        Green:
                      </span>
                      <input
                        className="newMaintenanceInput"
                        type="text"
                        value={selectedGreenPPFD}
                        onKeyDown={(e) => {
                          if (e.key === "Backspace" || e.key === "Delete")
                            return;
                          const isNumber = /[0-9]/.test(e.key);
                          const isDot = e.key === ".";
                          const hasDot = e.target.value.includes(".");
                          if ((!isNumber && !isDot) || (isDot && hasDot)) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value !== "") {
                            const ppfdValue = parseFloat(value);
                            if (ppfdValue > 2500) {
                              alert(
                                "Light intensity (PPFD) should be between 0 and 2500"
                              );
                              return;
                            }
                          }
                          if (value === "" || /^\d*\.?\d*$/.test(value)) {
                            if (
                              value.includes(".") &&
                              value.split(".")[1]?.length > 1
                            ) {
                              return;
                            }
                            setSelectedGreenPPFD(value);
                          }
                        }}
                      />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ width: "50px", marginRight: "10px" }}>
                        Blue:
                      </span>
                      <input
                        className="newMaintenanceInput"
                        type="text"
                        value={selectedBluePPFD}
                        onKeyDown={(e) => {
                          if (e.key === "Backspace" || e.key === "Delete")
                            return;
                          const isNumber = /[0-9]/.test(e.key);
                          const isDot = e.key === ".";
                          const hasDot = e.target.value.includes(".");
                          if ((!isNumber && !isDot) || (isDot && hasDot)) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value !== "") {
                            const ppfdValue = parseFloat(value);
                            if (ppfdValue > 2500) {
                              alert(
                                "Light intensity (PPFD) should be between 0 and 2500"
                              );
                              return;
                            }
                          }
                          if (value === "" || /^\d*\.?\d*$/.test(value)) {
                            if (
                              value.includes(".") &&
                              value.split(".")[1]?.length > 1
                            ) {
                              return;
                            }
                            setSelectedBluePPFD(value);
                          }
                        }}
                      />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ width: "50px", marginRight: "10px" }}>
                        Far Red:
                      </span>
                      <input
                        className="newMaintenanceInput"
                        type="text"
                        value={selectedFarRedPPFD}
                        onKeyDown={(e) => {
                          if (e.key === "Backspace" || e.key === "Delete")
                            return;
                          const isNumber = /[0-9]/.test(e.key);
                          const isDot = e.key === ".";
                          const hasDot = e.target.value.includes(".");
                          if ((!isNumber && !isDot) || (isDot && hasDot)) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value !== "") {
                            const ppfdValue = parseFloat(value);
                            if (ppfdValue > 2500) {
                              alert(
                                "Light intensity (PPFD) should be between 0 and 2500"
                              );
                              return;
                            }
                          }
                          if (value === "" || /^\d*\.?\d*$/.test(value)) {
                            if (
                              value.includes(".") &&
                              value.split(".")[1]?.length > 1
                            ) {
                              return;
                            }
                            setSelectedFarRedPPFD(value);
                          }
                        }}
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        ) : openSubs.has("flowerThickness") ? (
          <table className="maintenanceTable">
            <tbody>
              <tr>
                <td>
                  <p>Flower thickness:</p>
                </td>
                <td style={{ position: "relative" }}>
                  <input
                    className="newMaintenanceInput"
                    type="text"
                    value={selectedFlowerThickness}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" || e.key === "Delete") return;
                      const isNumber = /[0-9]/.test(e.key);
                      const isDot = e.key === ".";
                      const hasDot = e.target.value.includes(".");
                      if ((!isNumber && !isDot) || (isDot && hasDot)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d*\.?\d*$/.test(value)) {
                        if (
                          value.includes(".") &&
                          value.split(".")[1]?.length > 1
                        ) {
                          return;
                        }
                        setSelectedFlowerThickness(value);
                      }
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "10.5vw",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#666",
                    }}
                  >
                    mm
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        ) : openSubs.has("weight") ? (
          <table className="maintenanceTable">
            <tbody>
              <tr>
                <td>
                  <p>Weight:</p>
                </td>
                <td style={{ position: "relative" }}>
                  <input
                    className="newMaintenanceInput"
                    type="text"
                    value={selectedWeight}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" || e.key === "Delete") return;
                      const isNumber = /[0-9]/.test(e.key);
                      const isDot = e.key === ".";
                      const hasDot = e.target.value.includes(".");
                      if ((!isNumber && !isDot) || (isDot && hasDot)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d*\.?\d*$/.test(value)) {
                        if (
                          value.includes(".") &&
                          value.split(".")[1]?.length > 1
                        ) {
                          return;
                        }
                        setSelectedWeight(value);
                      }
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "14vw",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#666",
                    }}
                  >
                    g
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <p>Includes:</p>
                </td>
                <td>
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
                  >
                    <label style={{ display: "flex", alignItems: "center" }}>
                      <input
                        type="radio"
                        name="includes"
                        value="plant_container_substrate"
                        checked={
                          selectedWeightIncludes === "plant_container_substrate"
                        }
                        onChange={(e) =>
                          setSelectedWeightIncludes(e.target.value)
                        }
                        className="tableRadio tableRadioScouting"
                      />
                      Plant, substrate and container
                    </label>
                    <label style={{ display: "flex", alignItems: "center" }}>
                      <input
                        type="radio"
                        name="includes"
                        value="plant_substrate"
                        checked={selectedWeightIncludes === "plant_substrate"}
                        onChange={(e) =>
                          setSelectedWeightIncludes(e.target.value)
                        }
                        className="tableRadio tableRadioScouting"
                      />
                      Plant and substrate
                    </label>
                    <label style={{ display: "flex", alignItems: "center" }}>
                      <input
                        type="radio"
                        name="includes"
                        value="plant_only"
                        checked={selectedWeightIncludes === "plant_only"}
                        onChange={(e) =>
                          setSelectedWeightIncludes(e.target.value)
                        }
                        className="tableRadio tableRadioScouting"
                      />
                      Only plant
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        ) : null}
      </div>
    </>
  );
}
